import { createGlobalStyle, styled } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  body, html {
    background: aliceblue;
    font-family: 'Roboto', sans-serif;
    margin: 0;
    padding: 0;
    height: 100%;
    overflow: hidden; /* Strictly prevents page scrolling */
  }
`;

export const Wrapper = styled.div`
  background-image: url("../../banner.jpg");
  background-size: cover !important;
  background-position: center !important;
  position: relative;
  z-index: 1;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Keeps the login box centered and footer at the extreme bottom */
  align-items: center;
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 2rem;
  width: 100%;

  .login-box {
    border-radius: 20px;
    background: #ffffff;
    text-align: center;
    box-shadow:
      0 3px 6px rgba(0, 0, 0, 0.16),
      0 3px 6px rgba(0, 0, 0, 0.23);
    padding: 2rem;
    width: 100%;
    max-width: 450px; /* Ensures it looks good if Bootstrap containers scale up */

    /* Mobile scaling to prevent vertical overflow on short screens */
    @media (max-width: 576px) {
      padding: 1.5rem;
      margin: 0 15px; /* Adds a clean margin on the left/right of the mobile screen */
    }
  }

  .login-key {
    font-size: 80px;
    line-height: 100px;
    background: -webkit-linear-gradient(#27ef9f, #0db8de);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    @media (max-width: 576px) {
      font-size: 50px; /* Scales down the icon on small screens */
      line-height: 60px;
    }
  }

  .login-title {
    text-align: center;
    font-size: 20px;
    letter-spacing: 2px;
    margin-top: 15px;
    font-weight: bold;
    color: #94989d;

    @media (max-width: 576px) {
      font-size: 18px;
      margin-top: 10px;
    }
  }

  .company-title {
    text-align: center;
    font-size: 25px;
    font-weight: 500;
    color: #000204;

    img {
      @media (max-width: 576px) {
        width: 8rem !important; /* Slightly scales down the logo size on mobile */
      }
    }
  }

  .login-form {
    margin-top: 15px;
    text-align: left;

    @media (max-width: 576px) {
      margin-top: 5px;
    }
  }

  .form-group {
    margin-bottom: 20px;
    outline: 0px;

    @media (max-width: 576px) {
      margin-bottom: 15px; /* Saves vertical real estate */
    }
  }

  input:focus {
    outline: none;
    box-shadow: 0 0 0;
  }

  .btn-outline-primary {
    border-color: #0f5090;
    color: #0f5090;
    border-radius: 4px;
    font-weight: bold;
    letter-spacing: 1px;
    box-shadow:
      0 1px 3px rgba(0, 0, 0, 0.12),
      0 1px 2px rgba(0, 0, 0, 0.24);
    transition: all 0.2s ease-in-out;

    @media (max-width: 576px) {
      width: 100%; /* Makes login button full-width on mobile for better thumb reach */
      text-align: center;
    }
  }

  .btn-outline-primary:hover {
    background-color: #0f5090;
    color: #ffff;
  }

  .loginbttm {
    padding: 0px;
  }
`;

export const LogoContainer = styled.span``;

export const FooterInfo = styled.div`
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  padding: 15px 0;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(5px);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;

  /* Mobile layout transforms text layout to stack vertically */
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
    padding: 12px 0;
    font-size: 13px;
  }

  a {
    color: #0f5090;
    text-decoration: none;
    transition: color 0.2s ease-in-out;

    &:hover {
      color: #ef9f27;
      text-decoration: underline;
    }
  }

  .separator {
    color: #94989d;
    user-select: none;

    /* Hides the desktop line breaks (|) on small devices since content is stacked */
    @media (max-width: 768px) {
      display: none;
    }
  }
`;
